import { body, request } from "services/request";

const resource = "api/atiSu";

const getOrganizationInfo = () => request(`${resource}/getOrganizationInfo`, { method: "GET" });
const getDriverList = () => request(`${resource}/getDriverList`, { method: "GET" });
const getTruckList = () => request(`${resource}/getTruckList`, { method: "GET" });
const applyDrivers = () => request(`${resource}/applyDrivers`, body({}));
const applyTrucks = () => request(`${resource}/applyTrucks`, body({}));

export { applyDrivers, applyTrucks, getDriverList, getOrganizationInfo, getTruckList };
